export enum EmailDeliveryStatus {
  /// Email has been sent to server. No event has been generated.
  Recieved = 0,

  /// The email has been processed and is ready for sending.
  Processed = 1,

  /// The email was processed but dropped.
  Dropped = 2,

  /// The email was successfully delivered to the recipients email server.
  Delivered = 3,

  /// The email was delayed for some reason
  Deferred = 4,

  /// The email bounced
  Bounce = 5,

  /// The email is temporaryily blocked
  Blocked = 6,

  /// Message has been opened by recipient.
  Open = 7,

  /// Message has been opened by recipient and a link inside the message has been clicked.
  Click = 8,

  /// Message has been opened by recipient and unsubscribe was requested.
  Unsubscribe = 9,

  /// Message has been opened by recipient who then reported the message as spam.
  SpamReport = 10,

  /// Not delivered email the last 7 days.
  NotDeliveredLastWeek = 30,
}

export function EmailDeliveryStatusToString(status: EmailDeliveryStatus) {
  switch (status) {
    case EmailDeliveryStatus.Recieved:
    case EmailDeliveryStatus.Processed:
      return 'CONST.EMAIL_DELIVERY_STATUS_QUEUED';
    case EmailDeliveryStatus.Dropped:
    case EmailDeliveryStatus.Bounce:
      return 'CONST.EMAIL_DELIVERY_STATUS_DROPPED';
    case EmailDeliveryStatus.Deferred:
    case EmailDeliveryStatus.Blocked:
      return 'CONST.EMAIL_DELIVERY_STATUS_DEFERRED';
    case EmailDeliveryStatus.Delivered:
      return 'CONST.EMAIL_DELIVERY_STATUS_DELIVERED';
    case EmailDeliveryStatus.Open:
    case EmailDeliveryStatus.Click:
    case EmailDeliveryStatus.Unsubscribe:
      return 'CONST.EMAIL_DELIVERY_STATUS_OPEN';
    case EmailDeliveryStatus.SpamReport:
      return 'CONST.EMAIL_DELIVERY_STATUS_SPAMREPORT';
    case EmailDeliveryStatus.NotDeliveredLastWeek:
      return 'CONST.EMAIL_DELIVERY_STATUS_DROPPED_LAST_WEEK';

    default:
      throw new Error('Unsupported email delivery status.');
  }
}

export enum EmailStatus {
  Created = 1,
  Sent = 2,
  Invalid = 3,
  Delivered = 4,
}

export function EmailStatusToString(status: EmailStatus) {
  switch (status) {
    case EmailStatus.Created:
      return 'CONST.MAIL_STATUS_CREATED';
    case EmailStatus.Invalid:
      return 'CONST.MAIL_STATUS_INVALID';
    case EmailStatus.Sent:
      return 'CONST.MAIL_STATUS_SENT';
    case EmailStatus.Delivered:
      return 'CONST.MAIL_STATUS_DELIVERED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export enum MailStatus {
  Created = 1,
  Sent = 2,
  Invalid = 3,
  Delivered = 4,
}

export function MailStatusToString(status: MailStatus) {
  switch (status) {
    case MailStatus.Created:
      return 'CONST.MAIL_STATUS_CREATED';
    case MailStatus.Invalid:
      return 'CONST.MAIL_STATUS_INVALID';
    case MailStatus.Sent:
      return 'CONST.MAIL_STATUS_SENT';
    case MailStatus.Delivered:
      return 'CONST.MAIL_STATUS_DELIVERED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export enum SmsStatus {
  Created = 1,
  Sent = 2,
  Invalid = 3,
  Delivered = 4,
}

export function SmsStatusToString(status: SmsStatus) {
  switch (status) {
    case SmsStatus.Created:
      return 'CONST.MAIL_STATUS_CREATED';
    case SmsStatus.Invalid:
      return 'CONST.MAIL_STATUS_INVALID';
    case SmsStatus.Sent:
      return 'CONST.MAIL_STATUS_SENT';
    case SmsStatus.Delivered:
      return 'CONST.MAIL_STATUS_DELIVERED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

const UNIT_ERROR = 'Invalid entry unit.';
